






import { Component, Vue } from 'vue-property-decorator';
import CompleteNewPassword from '@/components/auth/CompleteNewPassword.vue';

@Component({
  components: {
    CompleteNewPassword,
  },
})
export default class CompleteNewPasswordScreen extends Vue { }
